// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Js_dict = require("@rescript/std/lib/js/js_dict.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var Nullable = require("../../Nullable.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Type_Image = require("../../type/Type_Image.bs.js");
var Util_Array = require("../../util/Util_Array.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("../../type/Type_Common.bs.js");
var Type_Credit = require("../../type/Type_Credit.bs.js");
var Type_String = require("../../type/Type_String.bs.js");
var Type_Teaser = require("../../type/Type_Teaser.bs.js");
var Type_Sticker = require("../../type/Type_Sticker.bs.js");
var $$Date = require("@artegeie/date");

function kind_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "code",
                    false,
                    Type_Common.programKind_encode(v.code)
                  ]]));
}

function kind_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var code = Type_Common.programKind_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "code"), null));
  if (code.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              code: code._0
            }
          };
  }
  var e = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var sizes = {
  TAG: /* Mami */0,
  _0: [
    /* W400xH225 */8,
    /* W300xH450 */9,
    /* W720xH406 */5,
    /* W1920xH1080 */0,
    /* W200xH200 */11,
    /* W400xH400 */7
  ]
};

function mainImage_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "caption",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.caption)
                  ],
                  [
                    "url",
                    false,
                    Spice.stringToJson(v.url)
                  ]
                ]));
}

function mainImage_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var caption = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "caption"), null));
  if (caption.TAG === /* Ok */0) {
    var url = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                caption: caption._0,
                url: url._0
              }
            };
    }
    var e = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = caption._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".caption" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function availability_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "type",
                    false,
                    Type_Common.availabilityType_encode(v.type)
                  ],
                  [
                    "start",
                    false,
                    Spice.stringToJson(v.start)
                  ],
                  [
                    "end",
                    false,
                    Spice.stringToJson(v.end)
                  ],
                  [
                    "upcomingDate",
                    false,
                    Spice.stringToJson(v.upcomingDate)
                  ]
                ]));
}

function availability_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var type = Type_Common.availabilityType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
  if (type.TAG === /* Ok */0) {
    var start = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
    if (start.TAG === /* Ok */0) {
      var end = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end"), null));
      if (end.TAG === /* Ok */0) {
        var upcomingDate = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "upcomingDate"), null));
        if (upcomingDate.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    type: type._0,
                    start: start._0,
                    end: end._0,
                    upcomingDate: upcomingDate._0
                  }
                };
        }
        var e = upcomingDate._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".upcomingDate" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = end._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".end" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = start._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".start" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".type" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function partner_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "title",
                    false,
                    Spice.stringToJson(v.title)
                  ],
                  [
                    "url",
                    false,
                    Spice.stringToJson(v.url)
                  ],
                  [
                    "image",
                    false,
                    mainImage_encode(v.image)
                  ]
                ]));
}

function partner_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var url = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      var image = mainImage_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
      if (image.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  title: title._0,
                  url: url._0,
                  image: image._0
                }
              };
      }
      var e = image._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".image" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function player_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "config",
                    false,
                    Spice.stringToJson(v.config)
                  ],
                  [
                    "playlist",
                    false,
                    Spice.stringToJson(v.playlist)
                  ],
                  [
                    "orangeVideoId",
                    false,
                    Spice.stringToJson(v.orangeVideoId)
                  ],
                  [
                    "freeVideoId",
                    false,
                    Spice.stringToJson(v.freeVideoId)
                  ]
                ]));
}

function player_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var config = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "config"), null));
  if (config.TAG === /* Ok */0) {
    var playlist = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playlist"), null));
    if (playlist.TAG === /* Ok */0) {
      var orangeVideoId = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "orangeVideoId"), null));
      if (orangeVideoId.TAG === /* Ok */0) {
        var freeVideoId = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "freeVideoId"), null));
        if (freeVideoId.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    config: config._0,
                    playlist: playlist._0,
                    orangeVideoId: orangeVideoId._0,
                    freeVideoId: freeVideoId._0
                  }
                };
        }
        var e = freeVideoId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".freeVideoId" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = orangeVideoId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".orangeVideoId" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = playlist._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".playlist" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = config._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".config" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function trailer_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "config",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.config)
                  ]]));
}

function trailer_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var config = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "config"), null));
  if (config.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              config: config._0
            }
          };
  }
  var e = config._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".config" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function broadcastDates_encode(v) {
  return Spice.arrayToJson(Spice.stringToJson, v);
}

function broadcastDates_decode(v) {
  return Spice.arrayFromJson(Spice.stringFromJson, v);
}

function genre_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "label",
                    false,
                    Spice.stringToJson(v.label)
                  ],
                  [
                    "url",
                    false,
                    Spice.stringToJson(v.url)
                  ]
                ]));
}

function genre_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var url = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                label: label._0,
                url: url._0
              }
            };
    }
    var e = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function parentCollection_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "kind",
                    false,
                    Type_Common.programKind_encode(v.kind)
                  ]]));
}

function parentCollection_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var kind = Type_Common.programKind_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "kind"), null));
  if (kind.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              kind: kind._0
            }
          };
  }
  var e = kind._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".kind" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function geoblocking_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "code",
                    false,
                    Type_Common.geoblocking_encode(v.code)
                  ],
                  [
                    "label",
                    false,
                    Spice.stringToJson(v.label)
                  ]
                ]));
}

function geoblocking_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = Type_Common.geoblocking_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var label = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                code: code._0,
                label: label._0
              }
            };
    }
    var e = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function audioVersion_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "code",
                    false,
                    Spice.stringToJson(v.code)
                  ],
                  [
                    "label",
                    false,
                    Spice.stringToJson(v.label)
                  ]
                ]));
}

function audioVersion_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var label = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                code: code._0,
                label: label._0
              }
            };
    }
    var e = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function audioVersions_encode(v) {
  return Spice.arrayToJson(audioVersion_encode, v);
}

function audioVersions_decode(v) {
  return Spice.arrayFromJson(audioVersion_decode, v);
}

function t_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "audioVersions",
                    false,
                    Nullable.t_encode(audioVersions_encode, v.audioVersions)
                  ],
                  [
                    "availability",
                    false,
                    Nullable.t_encode(availability_encode, v.availability)
                  ],
                  [
                    "broadcastDates",
                    false,
                    Nullable.t_encode(broadcastDates_encode, v.broadcastDates)
                  ],
                  [
                    "callToAction",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.callToAction)
                  ],
                  [
                    "clip",
                    false,
                    Nullable.t_encode(trailer_encode, v.clip)
                  ],
                  [
                    "credits",
                    false,
                    Nullable.t_encode(Type_Credit.credits_encode, v.credits)
                  ],
                  [
                    "duration",
                    false,
                    Nullable.t_encode(Type_Common.duration_in_sec_from_js_encode, v.duration)
                  ],
                  [
                    "durationLabel",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.durationLabel)
                  ],
                  [
                    "description",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.description)
                  ],
                  [
                    "firstBroadcastDate",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.firstBroadcastDate)
                  ],
                  [
                    "fullDescription",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.fullDescription)
                  ],
                  [
                    "genre",
                    false,
                    Nullable.t_encode(genre_encode, v.genre)
                  ],
                  [
                    "geoblocking",
                    false,
                    Nullable.t_encode(geoblocking_encode, v.geoblocking)
                  ],
                  [
                    "id",
                    false,
                    Spice.stringToJson(v.id)
                  ],
                  [
                    "mainImage",
                    false,
                    mainImage_encode(v.mainImage)
                  ],
                  [
                    "kind",
                    false,
                    Nullable.t_encode(kind_encode, v.kind)
                  ],
                  [
                    "parentCollections",
                    false,
                    Nullable.t_encode((function (param) {
                            return Spice.arrayToJson(parentCollection_encode, param);
                          }), v.parentCollections)
                  ],
                  [
                    "partners",
                    false,
                    Nullable.t_encode((function (param) {
                            return Spice.arrayToJson(partner_encode, param);
                          }), v.partners)
                  ],
                  [
                    "player",
                    false,
                    Nullable.t_encode(player_encode, v.player)
                  ],
                  [
                    "programId",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.programId)
                  ],
                  [
                    "publishEnd",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.publishEnd)
                  ],
                  [
                    "shopUrl",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.shopUrl)
                  ],
                  [
                    "shortDescription",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.shortDescription)
                  ],
                  [
                    "stickers",
                    false,
                    Nullable.t_encode(Type_Common.stickers_encode, v.stickers)
                  ],
                  [
                    "subtitle",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.subtitle)
                  ],
                  [
                    "teaserText",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.teaserText)
                  ],
                  [
                    "title",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.title)
                  ],
                  [
                    "trailer",
                    false,
                    Nullable.t_encode(trailer_encode, v.trailer)
                  ],
                  [
                    "trackingPixel",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.trackingPixel)
                  ],
                  [
                    "url",
                    false,
                    Spice.stringToJson(v.url)
                  ]
                ]));
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var audioVersions = Nullable.t_decode(audioVersions_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "audioVersions"), null));
  if (audioVersions.TAG === /* Ok */0) {
    var availability = Nullable.t_decode(availability_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "availability"), null));
    if (availability.TAG === /* Ok */0) {
      var broadcastDates = Nullable.t_decode(broadcastDates_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "broadcastDates"), null));
      if (broadcastDates.TAG === /* Ok */0) {
        var callToAction = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "callToAction"), null));
        if (callToAction.TAG === /* Ok */0) {
          var clip = Nullable.t_decode(trailer_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "clip"), null));
          if (clip.TAG === /* Ok */0) {
            var credits = Nullable.t_decode(Type_Credit.credits_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "credits"), null));
            if (credits.TAG === /* Ok */0) {
              var duration = Nullable.t_decode(Type_Common.duration_in_sec_from_js_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "duration"), null));
              if (duration.TAG === /* Ok */0) {
                var durationLabel = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "durationLabel"), null));
                if (durationLabel.TAG === /* Ok */0) {
                  var description = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
                  if (description.TAG === /* Ok */0) {
                    var firstBroadcastDate = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstBroadcastDate"), null));
                    if (firstBroadcastDate.TAG === /* Ok */0) {
                      var fullDescription = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fullDescription"), null));
                      if (fullDescription.TAG === /* Ok */0) {
                        var genre = Nullable.t_decode(genre_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "genre"), null));
                        if (genre.TAG === /* Ok */0) {
                          var geoblocking = Nullable.t_decode(geoblocking_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "geoblocking"), null));
                          if (geoblocking.TAG === /* Ok */0) {
                            var id = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
                            if (id.TAG === /* Ok */0) {
                              var mainImage = mainImage_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mainImage"), null));
                              if (mainImage.TAG === /* Ok */0) {
                                var kind = Nullable.t_decode(kind_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "kind"), null));
                                if (kind.TAG === /* Ok */0) {
                                  var parentCollections = Nullable.t_decode((function (param) {
                                          return Spice.arrayFromJson(parentCollection_decode, param);
                                        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentCollections"), null));
                                  if (parentCollections.TAG === /* Ok */0) {
                                    var partners = Nullable.t_decode((function (param) {
                                            return Spice.arrayFromJson(partner_decode, param);
                                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "partners"), null));
                                    if (partners.TAG === /* Ok */0) {
                                      var player = Nullable.t_decode(player_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "player"), null));
                                      if (player.TAG === /* Ok */0) {
                                        var programId = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "programId"), null));
                                        if (programId.TAG === /* Ok */0) {
                                          var publishEnd = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "publishEnd"), null));
                                          if (publishEnd.TAG === /* Ok */0) {
                                            var shopUrl = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "shopUrl"), null));
                                            if (shopUrl.TAG === /* Ok */0) {
                                              var shortDescription = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "shortDescription"), null));
                                              if (shortDescription.TAG === /* Ok */0) {
                                                var stickers = Nullable.t_decode(Type_Common.stickers_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "stickers"), null));
                                                if (stickers.TAG === /* Ok */0) {
                                                  var subtitle = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subtitle"), null));
                                                  if (subtitle.TAG === /* Ok */0) {
                                                    var teaserText = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "teaserText"), null));
                                                    if (teaserText.TAG === /* Ok */0) {
                                                      var title = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
                                                      if (title.TAG === /* Ok */0) {
                                                        var trailer = Nullable.t_decode(trailer_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trailer"), null));
                                                        if (trailer.TAG === /* Ok */0) {
                                                          var trackingPixel = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trackingPixel"), null));
                                                          if (trackingPixel.TAG === /* Ok */0) {
                                                            var url = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
                                                            if (url.TAG === /* Ok */0) {
                                                              return {
                                                                      TAG: /* Ok */0,
                                                                      _0: {
                                                                        audioVersions: audioVersions._0,
                                                                        availability: availability._0,
                                                                        broadcastDates: broadcastDates._0,
                                                                        callToAction: callToAction._0,
                                                                        clip: clip._0,
                                                                        credits: credits._0,
                                                                        duration: duration._0,
                                                                        durationLabel: durationLabel._0,
                                                                        description: description._0,
                                                                        firstBroadcastDate: firstBroadcastDate._0,
                                                                        fullDescription: fullDescription._0,
                                                                        genre: genre._0,
                                                                        geoblocking: geoblocking._0,
                                                                        id: id._0,
                                                                        mainImage: mainImage._0,
                                                                        kind: kind._0,
                                                                        parentCollections: parentCollections._0,
                                                                        partners: partners._0,
                                                                        player: player._0,
                                                                        programId: programId._0,
                                                                        publishEnd: publishEnd._0,
                                                                        shopUrl: shopUrl._0,
                                                                        shortDescription: shortDescription._0,
                                                                        stickers: stickers._0,
                                                                        subtitle: subtitle._0,
                                                                        teaserText: teaserText._0,
                                                                        title: title._0,
                                                                        trailer: trailer._0,
                                                                        trackingPixel: trackingPixel._0,
                                                                        url: url._0
                                                                      }
                                                                    };
                                                            }
                                                            var e = url._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".url" + e.path,
                                                                      message: e.message,
                                                                      value: e.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$1 = trackingPixel._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".trackingPixel" + e$1.path,
                                                                    message: e$1.message,
                                                                    value: e$1.value
                                                                  }
                                                                };
                                                        }
                                                        var e$2 = trailer._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".trailer" + e$2.path,
                                                                  message: e$2.message,
                                                                  value: e$2.value
                                                                }
                                                              };
                                                      }
                                                      var e$3 = title._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".title" + e$3.path,
                                                                message: e$3.message,
                                                                value: e$3.value
                                                              }
                                                            };
                                                    }
                                                    var e$4 = teaserText._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".teaserText" + e$4.path,
                                                              message: e$4.message,
                                                              value: e$4.value
                                                            }
                                                          };
                                                  }
                                                  var e$5 = subtitle._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".subtitle" + e$5.path,
                                                            message: e$5.message,
                                                            value: e$5.value
                                                          }
                                                        };
                                                }
                                                var e$6 = stickers._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".stickers" + e$6.path,
                                                          message: e$6.message,
                                                          value: e$6.value
                                                        }
                                                      };
                                              }
                                              var e$7 = shortDescription._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".shortDescription" + e$7.path,
                                                        message: e$7.message,
                                                        value: e$7.value
                                                      }
                                                    };
                                            }
                                            var e$8 = shopUrl._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".shopUrl" + e$8.path,
                                                      message: e$8.message,
                                                      value: e$8.value
                                                    }
                                                  };
                                          }
                                          var e$9 = publishEnd._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".publishEnd" + e$9.path,
                                                    message: e$9.message,
                                                    value: e$9.value
                                                  }
                                                };
                                        }
                                        var e$10 = programId._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".programId" + e$10.path,
                                                  message: e$10.message,
                                                  value: e$10.value
                                                }
                                              };
                                      }
                                      var e$11 = player._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".player" + e$11.path,
                                                message: e$11.message,
                                                value: e$11.value
                                              }
                                            };
                                    }
                                    var e$12 = partners._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".partners" + e$12.path,
                                              message: e$12.message,
                                              value: e$12.value
                                            }
                                          };
                                  }
                                  var e$13 = parentCollections._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".parentCollections" + e$13.path,
                                            message: e$13.message,
                                            value: e$13.value
                                          }
                                        };
                                }
                                var e$14 = kind._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".kind" + e$14.path,
                                          message: e$14.message,
                                          value: e$14.value
                                        }
                                      };
                              }
                              var e$15 = mainImage._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".mainImage" + e$15.path,
                                        message: e$15.message,
                                        value: e$15.value
                                      }
                                    };
                            }
                            var e$16 = id._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".id" + e$16.path,
                                      message: e$16.message,
                                      value: e$16.value
                                    }
                                  };
                          }
                          var e$17 = geoblocking._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".geoblocking" + e$17.path,
                                    message: e$17.message,
                                    value: e$17.value
                                  }
                                };
                        }
                        var e$18 = genre._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".genre" + e$18.path,
                                  message: e$18.message,
                                  value: e$18.value
                                }
                              };
                      }
                      var e$19 = fullDescription._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".fullDescription" + e$19.path,
                                message: e$19.message,
                                value: e$19.value
                              }
                            };
                    }
                    var e$20 = firstBroadcastDate._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".firstBroadcastDate" + e$20.path,
                              message: e$20.message,
                              value: e$20.value
                            }
                          };
                  }
                  var e$21 = description._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".description" + e$21.path,
                            message: e$21.message,
                            value: e$21.value
                          }
                        };
                }
                var e$22 = durationLabel._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".durationLabel" + e$22.path,
                          message: e$22.message,
                          value: e$22.value
                        }
                      };
              }
              var e$23 = duration._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".duration" + e$23.path,
                        message: e$23.message,
                        value: e$23.value
                      }
                    };
            }
            var e$24 = credits._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".credits" + e$24.path,
                      message: e$24.message,
                      value: e$24.value
                    }
                  };
          }
          var e$25 = clip._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".clip" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
        }
        var e$26 = callToAction._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".callToAction" + e$26.path,
                  message: e$26.message,
                  value: e$26.value
                }
              };
      }
      var e$27 = broadcastDates._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".broadcastDates" + e$27.path,
                message: e$27.message,
                value: e$27.value
              }
            };
    }
    var e$28 = availability._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".availability" + e$28.path,
              message: e$28.message,
              value: e$28.value
            }
          };
  }
  var e$29 = audioVersions._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".audioVersions" + e$29.path,
            message: e$29.message,
            value: e$29.value
          }
        };
}

function getAvailabilitySticker(timeReference, dateFormater, availability) {
  var __x = (availability == null) ? undefined : Caml_option.some(availability);
  return Belt_Option.map(Belt_Option.flatMap(__x, (function (param) {
                    var start = new Date(param.start);
                    if ($$Date.isAfter(start, timeReference)) {
                      return {
                              type_: param.type,
                              start: start
                            };
                    }
                    
                  })), dateFormater);
}

function addToStickers(availabilitySticker, stickers, availability) {
  var type_ = availability !== undefined ? availability.type : undefined;
  return Belt_Option.getWithDefault(Belt_Option.map(availabilitySticker, (function (text) {
                    var match = Type_String.NotEmpty.make(text);
                    if (match === undefined) {
                      return stickers;
                    }
                    var text$1 = Caml_option.valFromOption(match);
                    if (type_ !== undefined && (type_ === "LIVESTREAM_WEB" || type_ === "LIVESTREAM_TV")) {
                      return Type_Sticker.updateTopLeft(stickers, {
                                  NAME: "Livestream",
                                  VAL: text$1
                                });
                    } else {
                      return Type_Sticker.updateTopLeft(stickers, {
                                  NAME: "AvailableOn",
                                  VAL: text$1
                                });
                    }
                  })), stickers);
}

function addAvailabilitySticker(timeReference, teaserKind, dateFormater, availability, stickers) {
  var match = Type_Teaser.Kind.view(teaserKind);
  var match$1 = stickers.topLeft;
  if (match === "Standard" && match$1 === undefined) {
    return addToStickers(getAvailabilitySticker(timeReference, dateFormater, availability), stickers, (availability == null) ? undefined : Caml_option.some(availability));
  } else {
    return stickers;
  }
}

function getAvailabilityLabel(timeReference, betweenDatesFormater, start, end_) {
  var start$1 = new Date(start);
  var end_$1 = new Date(end_);
  var isBetween = $$Date.isBetween(start$1, end_$1, timeReference);
  var args = isBetween ? ({
        start: start$1,
        end_: end_$1
      }) : undefined;
  return Belt_Option.map(args, betweenDatesFormater);
}

function formatBroadcastDates(nextBroadcastDateFormater, broadcastDates) {
  return Belt_Option.map(broadcastDates, (function (broadcastDates) {
                return Belt_Array.reduce(broadcastDates, [], (function (accumulator, broadcastDate) {
                              var date = new Date(broadcastDate);
                              var isFuture = $$Date.isAfter(date, new Date(Date.now()));
                              if (!isFuture) {
                                return accumulator;
                              }
                              var dateFormat = Curry._1(Type_String.Teaser.BroadcastDate.make, Curry._1(nextBroadcastDateFormater, date));
                              return Belt_Array.concat(accumulator, [dateFormat]);
                            }));
              }));
}

function getProgramKind(kind, parentCollections) {
  var withParentCollection = function (code) {
    if (code === "MAGAZINE") {
      return "MAGAZINE";
    } else if (parentCollections == null) {
      return code;
    } else {
      return Belt_Option.getWithDefault(Belt_Option.map(Caml_option.undefined_to_opt(parentCollections.find(function (param) {
                              return param.kind === "MAGAZINE";
                            })), (function (param) {
                        return param.kind;
                      })), code);
    }
  };
  return Belt_Option.map(Belt_Option.map((kind == null) ? undefined : Caml_option.some(kind), (function (param) {
                    return param.code;
                  })), withParentCollection);
}

function toResolutions(url, sizes) {
  if (sizes.TAG === /* Mami */0) {
    return Belt_Array.map(sizes._0, (function (imageSize) {
                  var match = Curry._1(Type_Image.Mami.Size.toDimensions, imageSize);
                  return Type_Teaser.makeResolution(url.replace("__SIZE__", Curry._1(Type_Image.Mami.Size.toString, imageSize)), match.width | 0, match.height | 0);
                }));
  } else {
    return [Type_Teaser.makeResolution(url, sizes.width, sizes.height)];
  }
}

function toDsPartner(param) {
  return {
          title: param.title,
          url: param.url,
          resolutions: toResolutions(param.image.url, sizes)
        };
}

function toDsTeaser(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, template, zoneId, zoneItemTitle, pageKind, param) {
  var kind = param.kind;
  var mainImage = param.mainImage;
  var availability = param.availability;
  var parentPage = pageKind !== undefined ? (
      typeof pageKind === "number" ? (
          pageKind === /* Concert */0 ? ({
                domain: /* Concert */1,
                pageKind: pageKind
              }) : ({
                domain: /* Replay */0,
                pageKind: pageKind
              })
        ) : (
          pageKind.TAG === /* Guide */0 && !pageKind._0 ? ({
                domain: /* Concert */1,
                pageKind: pageKind
              }) : ({
                domain: /* Replay */0,
                pageKind: pageKind
              })
        )
    ) : ({
        domain: /* Replay */0,
        pageKind: pageKind
      });
  var duration = Belt_Option.map(Caml_option.nullable_to_opt(param.duration), Type_Common.jsSecondDurationToDuration);
  var durationLabel = Curry._1(Type_String.Teaser.DurationLabel.makeFromNullable, param.durationLabel);
  var stickers = Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(param.stickers), Type_Sticker.makeFromCommonStickers), Type_Sticker.empty);
  var teaserKind = Type_Teaser.Kind.fromStickers(stickers);
  var stickers$1 = addAvailabilitySticker(timeReference, teaserKind, dateFormater, availability, Type_Teaser.Helper.addDurationSticker(durationLabel, teaserKind, stickers));
  var programId = Curry._1(Type_String.Program.Id.makeFromNullable, param.programId);
  var programKind = getProgramKind(kind, param.parentCollections);
  var teaserId = Curry._1(Type_String.Teaser.Id.make, param.id);
  var dsId = Type_Teaser.Helper.makeDsId(programId, teaserId);
  var key = Type_Teaser.Helper.makeKey(zoneId, dsId);
  var match = Curry._1(Type_String.Teaser.Title.makeFromNullable, param.title);
  var match$1 = Type_Teaser.Kind.view(teaserKind);
  var title;
  if (match !== undefined) {
    var exit = 0;
    if (template === "horizontal-portrait") {
      title = {
        TAG: /* HoverOnly */2,
        _0: match
      };
    } else {
      exit = 1;
    }
    if (exit === 1) {
      title = match$1 === "Direct" || zoneItemTitle === undefined ? ({
            TAG: /* AccessibilityOnly */1,
            _0: match
          }) : ({
            TAG: /* Displayed */0,
            _0: match
          });
    }
    
  } else {
    title = undefined;
  }
  var tmp;
  if (kind == null) {
    tmp = /* NotAvailable */0;
  } else {
    var match$2 = kind.code;
    tmp = match$2 === "SHOW" || match$2 === "BONUS" || match$2 === "PLAYLIST" || match$2 === "TOPIC" || match$2 === "TV_SERIES" || match$2 === "HIGHLIGHT" || match$2 === "MAGAZINE" ? /* Available */({
          _0: /* NotFavorite */1
        }) : /* NotAvailable */0;
  }
  var match$3 = Type_Teaser.Kind.view(teaserKind);
  var match$4 = Curry._1(Type_String.Teaser.Subtitle.makeFromNullable, param.subtitle);
  var tmp$1;
  var exit$1 = 0;
  if (match$4 !== undefined) {
    var exit$2 = 0;
    if (template === "horizontal-portrait") {
      tmp$1 = {
        TAG: /* HoverOnly */2,
        _0: match$4
      };
    } else {
      exit$2 = 2;
    }
    if (exit$2 === 2) {
      if (title !== undefined) {
        exit$1 = 1;
      } else {
        tmp$1 = {
          TAG: /* SubtitleAsTitle */1,
          _0: match$4,
          _1: /* TitleStyle */0
        };
      }
    }
    
  } else {
    exit$1 = 1;
  }
  if (exit$1 === 1) {
    if (match$3 === "Direct") {
      if (match$4 !== undefined) {
        tmp$1 = {
          TAG: /* SubtitleAsTitle */1,
          _0: match$4,
          _1: /* TitleStyle */0
        };
      } else if (title !== undefined) {
        var subtitle = Curry._1(Type_String.Teaser.Subtitle.make, Type_Teaser.Helper.titleToString(title));
        tmp$1 = {
          TAG: /* SubtitleAsTitle */1,
          _0: subtitle,
          _1: /* TitleStyle */0
        };
      } else {
        tmp$1 = undefined;
      }
    } else {
      tmp$1 = zoneItemTitle !== undefined ? (
          zoneItemTitle ? (
              match$4 !== undefined ? ({
                    TAG: /* SubtitleAsTitle */1,
                    _0: match$4,
                    _1: /* SubtitleStyle */1
                  }) : undefined
            ) : (
              match$4 !== undefined ? ({
                    TAG: /* Normal */0,
                    _0: match$4
                  }) : undefined
            )
        ) : (
          match$4 !== undefined ? ({
                TAG: /* Normal */0,
                _0: match$4
              }) : undefined
        );
    }
  }
  return {
          audioVersions: Belt_Option.map(Caml_option.nullable_to_opt(param.audioVersions), (function (audioVersions) {
                  return Util_Array.catOption(Belt_Array.map(audioVersions, (function (audioVersion) {
                                    return Belt_Option.map(Type_Common.audioVersionCodeFromJs(audioVersion.code), (function (code) {
                                                  return {
                                                          code: code,
                                                          label: audioVersion.label
                                                        };
                                                }));
                                  })));
                })),
          availability: Belt_Option.map((availability == null) ? undefined : Caml_option.some(availability), (function (param) {
                  var start = param.start;
                  return {
                          type_: param.type,
                          label: getAvailabilityLabel(timeReference, betweenDatesFormater, start, param.end),
                          start: start,
                          upcomingDate: param.upcomingDate
                        };
                })),
          broadcastDates: formatBroadcastDates(nextBroadcastDateFormater, Caml_option.nullable_to_opt(param.broadcastDates)),
          callToAction: Type_String.CallToAction.makeFromNullable(param.callToAction),
          parentPage: parentPage,
          credits: Caml_option.nullable_to_opt(param.credits),
          description: Curry._1(Type_String.Teaser.Description.makeFromNullable, param.teaserText),
          dsId: dsId,
          duration: duration,
          durationLabel: durationLabel,
          favoriteStatus: tmp,
          href: Curry._1(Type_String.Href.make, param.url),
          geoblocking: Belt_Option.map(Caml_option.nullable_to_opt(param.geoblocking), (function (param) {
                  return {
                          code: param.code,
                          label: Curry._1(Type_String.Teaser.Geoblocking.Label.make, param.label)
                        };
                })),
          id: teaserId,
          imageSrc: programKind === "VOD" ? toResolutions(mainImage.url, {
                  TAG: /* Vod */1,
                  width: 600,
                  height: 800
                }) : toResolutions(mainImage.url, sizes),
          key: key,
          kind: teaserKind,
          partners: Belt_Option.map(Caml_option.nullable_to_opt(param.partners), (function (partners) {
                  return Belt_Array.map(partners, toDsPartner);
                })),
          program: {
            clip: Belt_Option.flatMap(Caml_option.nullable_to_opt(param.clip), (function (param) {
                    return Curry._1(Type_String.Program.Clip.makeFromNullable, param.config);
                  })),
            description: Caml_option.nullable_to_opt(param.fullDescription),
            firstBroadcastDate: Curry._1(Type_String.Program.FirstBroadcastDate.makeFromNullable, param.firstBroadcastDate),
            genre: Belt_Option.map(Caml_option.nullable_to_opt(param.genre), (function (param) {
                    return {
                            label: Curry._1(Type_String.Program.Genre.Label.make, param.label),
                            url: Curry._1(Type_String.Program.Genre.Url.make, param.url)
                          };
                  })),
            id: programId,
            kind: programKind,
            shortDescription: Caml_option.nullable_to_opt(param.shortDescription),
            trailer: Belt_Option.flatMap(Caml_option.nullable_to_opt(param.trailer), (function (param) {
                    return Curry._1(Type_String.Program.Trailer.makeFromNullable, param.config);
                  }))
          },
          progression: Type_Common.Progression.noProgression,
          shopUrl: Caml_option.nullable_to_opt(param.shopUrl),
          stickers: stickers$1,
          subtitle: tmp$1,
          title: title,
          trackingPixel: Type_String.TrackingPixel.makeFromNullable(param.trackingPixel),
          hoverBehavior: programKind === "VOD" ? /* Disabled */2 : /* Normal */1
        };
}

exports.kind_encode = kind_encode;
exports.kind_decode = kind_decode;
exports.sizes = sizes;
exports.mainImage_encode = mainImage_encode;
exports.mainImage_decode = mainImage_decode;
exports.availability_encode = availability_encode;
exports.availability_decode = availability_decode;
exports.partner_encode = partner_encode;
exports.partner_decode = partner_decode;
exports.player_encode = player_encode;
exports.player_decode = player_decode;
exports.trailer_encode = trailer_encode;
exports.trailer_decode = trailer_decode;
exports.broadcastDates_encode = broadcastDates_encode;
exports.broadcastDates_decode = broadcastDates_decode;
exports.genre_encode = genre_encode;
exports.genre_decode = genre_decode;
exports.parentCollection_encode = parentCollection_encode;
exports.parentCollection_decode = parentCollection_decode;
exports.geoblocking_encode = geoblocking_encode;
exports.geoblocking_decode = geoblocking_decode;
exports.audioVersion_encode = audioVersion_encode;
exports.audioVersion_decode = audioVersion_decode;
exports.audioVersions_encode = audioVersions_encode;
exports.audioVersions_decode = audioVersions_decode;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.getAvailabilitySticker = getAvailabilitySticker;
exports.addToStickers = addToStickers;
exports.addAvailabilitySticker = addAvailabilitySticker;
exports.getAvailabilityLabel = getAvailabilityLabel;
exports.formatBroadcastDates = formatBroadcastDates;
exports.getProgramKind = getProgramKind;
exports.toResolutions = toResolutions;
exports.toDsPartner = toDsPartner;
exports.toDsTeaser = toDsTeaser;
/* Type_Common Not a pure module */
